import { ScreeningTestFrequencyOption } from "@/Common/Models/UI/Inputs/DropDownOption";
import { ScreeningTestWarningIcon } from "@/Patient/Components/ScreeningTest/ScreeningTestWarningIcon";
import { MedicalItemScreeningTest } from "@/Patient/Models/MedicalSummary/MedicalItemScreeningTest";

interface IScreeningPlanProps {
    isEncounterSignedOff: boolean;
    isEditMode: boolean;
    screeningTests: MedicalItemScreeningTest[];
    selectItemCallback?: (screeningTest: MedicalItemScreeningTest) => void;
    addItemCallback?: () => void;
}

class ScreeningPlan extends React.Component<IScreeningPlanProps, any> {
    public render(): JSX.Element {
        let underlineStyle: React.CSSProperties = {};
        if (this.props.screeningTests && this.props.screeningTests.length) {
            underlineStyle = { textDecoration: "underline" };
        }

        if (!cacheStore.ClinicSettings.EnablePreventiveCareDashboard || (this.props.isEncounterSignedOff && isArrayNullOrUndefinedOrEmpty(this.props.screeningTests)))
            return null;

        return (
            <div className="patient-note separator">
                <table className="patient-note" data-cy="medicalNote-preventiveActivities">
                    <tbody>
                        <tr>
                            <td className="c1">
                                <strong style={underlineStyle}>
                                    {cacheStore.GetString("PreventiveActivityLabel")}
                                </strong>
                            </td>
                            <td className="c2">
                                <div className="tb-row" />
                            </td>
                            <td className="c3" />
                        </tr>
                        {this.renderScreeningTests()}
                        {!this.props.isEncounterSignedOff && (
                            <tr>
                                <td className="c1" />
                                <td className="c2">
                                    <div className="tb-row">
                                        {this.props.isEditMode && (
                                            <div>
                                                <a
                                                    data-cy="medicalNote-add-preventiveActivities"
                                                    onClick={() => {
                                                        patientStore.IsMedicalItemFromOutsideNote = false;
                                                        this.addItem();
                                                    }}
                                                >{"[+] "}
                                                </a>
                                                <strong>{cacheStore.GetString("PreventiveActivityLabel")}</strong>
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td className="c3" />
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    private renderScreeningTests(): JSX.Element[] {
        let result: JSX.Element[] = [];

        this.props.screeningTests.forEach(screening => {
            let model = screening.model;

            const invalidStyle = model.DisplayAsInvalid ? "invalid-medical-item" : "";
            const frequencyName = model.FrequencyTypeDropDownId ? ScreeningTestFrequencyOption.fromDropDownId(model.FrequencyTypeDropDownId)?.getNameAbbr?.() : "--";
            const screeningTestTitle = screening.getScreeningTestTitle();

            const itemRender = (
                <tr
                    key={"screeningTest_" + model.MedicalItemId}
                    className={"medical-note-item " + invalidStyle}
                    onClick={() => this.selectItem(screening)}
                >

                    <td className="c1">
                        <div className="tb-row tb">
                            <strong>
                                <span className={invalidStyle}> {frequencyName}</span>
                            </strong>
                        </div>
                    </td>
                    <td className="c2">
                        <div className="tb-row tb">
                            <div className="add-btn-column" />
                            <div className="flex-container">
                                <div>
                                    <a>
                                        <span className={invalidStyle}>
                                            {screeningTestTitle ?? "--"}
                                        </span>
                                    </a>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <a className={invalidStyle}> {screening.getStatusLocalizedValue()}</a>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td className="c3">
                        <ScreeningTestWarningIcon screeningTest={screening} />
                    </td>
                </tr>
            );

            result.push(itemRender);
            result.push(<tr key={"empty" + model.MedicalItemId}><td><span>&nbsp; </span></td><td /><td /></tr>);
        });

        return result;
    }

    private selectItem(screeningTest: MedicalItemScreeningTest): void {
        if (this.props.selectItemCallback)
            this.props.selectItemCallback(screeningTest);
    }

    private addItem(): void {
        if (this.props.addItemCallback)
            this.props.addItemCallback();
    }
}

export { ScreeningPlan };
